module.exports = __webpack_public_path__ + "img/icon_supplier_ddfh@2x.600f016d.png";